import React, { useState } from "react";
import { Image } from "antd";

type Props = {
  item: any;
};

const LoadedImage: any = ({ item }: Props) => {
  const [imgNotLoaded, setImgNotLoaded] = useState(false);

  return (
    <>
      {item && !imgNotLoaded ? (
        <Image
          width={100}
          src={(item?.url.slice(-2) == "=1") ? item?.url.replace("=1", "=200x140") : item?.url}
          fallback={(item?.url.slice(-2) == "=1") ? item?.url.replace("=1", "=200x140") : item?.url}
          onError={() => setImgNotLoaded(true)}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default LoadedImage;
